/* eslint-disable import/prefer-default-export */
export const appTypes = {
  updateHistory: '[nav] update history',
  addFunction: '[func] add function',
  updateUser: '[auth] update user',
  logoutUser: '[auth] logout user'
}
